export default __webpack_public_path__ + "static/media/featured-covetrus.66937fa0.webp";